
export default function AdministrationEntries() {


  return (
    <div>
      <table id="filetable">
        <tr>
          <th>File Name</th>
          <th>Date Posted</th>
        </tr>
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Recertification-of-Redevelopment-Area-Presentation.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Recertification of Redevelopment Area - Presentation to Council 11/18/25
            </a>
          </td>
          <td>11/19/2025</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Borough-Organizational-Chart.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Borough Organizational Chart
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Development-Map.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Development Map
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Guide-to-Borough-Services.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Guide To Borough Services
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/ICMA-Code-of-Ethics.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; ICMA Code of Ethics
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Morrisville-Borough-Ward-Map.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Morrisville Borough Ward Map
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Open-Space-2009.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Open Space Plan - 2009
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/administration/Open-Space-2009.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Open Space Plan - 2009
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
      </table>
    </div>

  );
}
